/**
 * ES PopCart Toast v10 — Essential Stencil
 *
 * v10: Integration alignment with cart drawer v2 + header v3
 *   - FIX 1: esc() helper for XSS-safe img alt attributes
 *   - FIX 2: Sticky ATC CSS selector uses .esatc class (not hardcoded ID)
 *   - FIX 3: Dispatches cart:updated after own /cart.js fetches
 *   - FIX 4: Removed dead updateCartCount() calls (header uses events)
 *
 * Upload to: Assets/es-popcart.js
 * Load in theme.liquid AFTER es-crosssell-engine.js
 */
(function () {
  'use strict';

  var TOAST_DURATION = 10000;
  var _timer = null;
  var _el = null;
  var _qvBuilt = false;
  var _qvOpen = false;
  var _currentRec = null;
  var _built = false;
  var _timerRemaining = 0;
  var _timerStart = 0;

  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }

  /* FIX 1: HTML escape helper — prevents broken DOM from product titles with quotes */
  function esc(s) { if (typeof s !== 'string') return ''; var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  function getThreshold() {
    var c = window.CDCSettings || {};
    return Math.round((c.shippingThreshold || c.tier1Threshold || 55) * 100);
  }

  /* FIX 3: Dispatch cart:updated so header/sticky ATC update instantly
     without needing their cdc:item-added fallback fetch */
  function broadcastCartUpdate(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cdc:cart-updated', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    } catch(e) {}
  }

  /* ════════════════════════════════════════
     TYPE LABEL from detectType
  ════════════════════════════════════════ */
  var TYPE_LABELS = {
    stencil: 'Reusable Stencil',
    transfer: 'Rub-on Transfer',
    tool: 'Brushes & Tools'
  };

  function getTypeLabel(product) {
    var type = window.ESCrossSell ? window.ESCrossSell.detectType(product) : 'stencil';
    return TYPE_LABELS[type] || 'Reusable Stencil';
  }

  /* ════════════════════════════════════════
     DIMENSIONS from handle
  ════════════════════════════════════════ */
  function extractDimensions(handle) {
    if (!handle) return '';
    var match = handle.match(/(\d+(?:-\d+)?)x(\d+(?:-\d+)?)/);
    if (!match) return '';
    var w = match[1].replace('-', '.');
    var h = match[2].replace('-', '.');
    return w + '" x ' + h + '"';
  }

  /* ════════════════════════════════════════
     BADGES from tags + publish date + price
  ════════════════════════════════════════ */
  function buildBadges(product) {
    var badges = [];
    var tags = (product.tags || '');
    if (typeof tags === 'string') tags = tags.split(',').map(function (t) { return t.trim().toLowerCase(); });
    else if (Array.isArray(tags)) tags = tags.map(function (t) { return (t || '').toLowerCase(); });
    else tags = [];

    if (tags.indexOf('best seller') !== -1) {
      badges.push({ text: 'Selling Fast', cls: 'es-pc-badge-green' });
    }

    var published = product.published_at || product.created_at;
    if (published) {
      var pubDate = new Date(published);
      var now = new Date();
      var daysSince = Math.floor((now - pubDate) / (1000 * 60 * 60 * 24));
      if (daysSince <= 30) {
        badges.push({ text: 'New', cls: 'es-pc-badge-blue' });
      }
    }

    var v = product.variants && product.variants[0];
    if (v && v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price)) {
      badges.push({ text: 'Sale', cls: 'es-pc-badge-red' });
    }

    return badges;
  }

  /* ════════════════════════════════════════
     DESCRIPTION EXTRACTION
  ════════════════════════════════════════ */
  function extractDescription(bodyHtml) {
    if (!bodyHtml) return '';
    var tmp = document.createElement('div');
    tmp.innerHTML = bodyHtml;
    var removeSelectors = ['[class*="accordion"]', '[class*="tab"]', '[class*="toggle"]', '[class*="collapsible"]', 'details', 'summary', 'dl', 'table'];
    removeSelectors.forEach(function (sel) {
      try { tmp.querySelectorAll(sel).forEach(function (el) { el.remove(); }); } catch (e) {}
    });
    var sectionHeadings = ['overview', 'shipping', 'guarantee', 'faq', 'frequently asked',
      'how to', 'instructions', 'details', 'specifications', 'reviews', 'what\'s included'];
    var headings = tmp.querySelectorAll('h1, h2, h3, h4, h5, h6, strong, b');
    var cutPoint = null;
    for (var i = 0; i < headings.length; i++) {
      var hText = (headings[i].textContent || '').toLowerCase().trim();
      for (var j = 0; j < sectionHeadings.length; j++) {
        if (hText.indexOf(sectionHeadings[j]) !== -1) { cutPoint = headings[i]; break; }
      }
      if (cutPoint) break;
    }
    if (cutPoint) {
      var parent = cutPoint.parentNode;
      var sibling = cutPoint;
      while (sibling) { var next = sibling.nextSibling; parent.removeChild(sibling); sibling = next; }
    }
    return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function extractBullets(bodyHtml) {
    if (!bodyHtml) return [];
    var tmp = document.createElement('div');
    tmp.innerHTML = bodyHtml;
    var lis = tmp.querySelectorAll('li');
    if (lis.length >= 2) {
      var out = [];
      for (var i = 0; i < Math.min(3, lis.length); i++) {
        var t = (lis[i].textContent || '').replace(/\s+/g, ' ').trim();
        if (t.length > 5 && t.length < 120) out.push(t);
      }
      if (out.length >= 2) return out;
    }
    return [];
  }

  /* ════════════════════════════════════════
     FETCH PRODUCT via .json (has body_html)
  ════════════════════════════════════════ */
  function fetchProductJson(handle) {
    return fetch('/products/' + handle + '.json', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) { return d.product || null; })
      .catch(function () { return null; });
  }

  /* ════════════════════════════════════════
     BUILD TOAST (once)
  ════════════════════════════════════════ */
  function build() {
    if (_built) return;
    _built = true;
    var el = document.createElement('div');
    el.id = 'es-popcart';
    el.innerHTML =
      '<div class="es-pc-confirm">' +
        '<div class="es-pc-check"><svg width="11" height="11" viewBox="0 0 10 8" fill="none"><path d="M1 4l3 3 5-6" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>' +
        '<div class="es-pc-msg">' +
          '<div class="es-pc-title" id="es-pc-title">Added to your cart!</div>' +
          '<div class="es-pc-sub" id="es-pc-sub">1 item in your cart</div>' +
        '</div>' +
        '<div class="es-pc-actions">' +
          '<button class="es-pc-view" id="es-pc-view" type="button">View cart</button>' +
          '<button class="es-pc-x" id="es-pc-x" type="button">&times;</button>' +
        '</div>' +
      '</div>' +
      '<div class="es-pc-rec" id="es-pc-rec">' +
        '<div class="es-pc-rec-card">' +
          '<div class="es-pc-rec-img es-pc-qv-trigger" id="es-pc-rec-img"></div>' +
          '<div class="es-pc-rec-info">' +
            '<div class="es-pc-rec-label" id="es-pc-rec-label">Makers also grab</div>' +
            '<div class="es-pc-rec-name es-pc-qv-trigger" id="es-pc-rec-name"></div>' +
            '<div class="es-pc-rec-pr"><span id="es-pc-rec-price"></span><span class="es-pc-rec-was" id="es-pc-rec-was"></span></div>' +
          '</div>' +
          '<div class="es-pc-rec-btns">' +
            '<button class="es-pc-rec-btn" id="es-pc-rec-btn" type="button">Add</button>' +
            '<button class="es-pc-qv-btn es-pc-qv-trigger" type="button">Quick view</button>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="es-pc-ship" id="es-pc-ship">' +
        '<div class="es-pc-ship-bar"><div class="es-pc-ship-fill" id="es-pc-ship-fill"></div></div>' +
        '<div class="es-pc-ship-text" id="es-pc-ship-text"></div>' +
      '</div>' +
      '<div class="es-pc-timer"><div class="es-pc-timer-fill" id="es-pc-timer-fill"></div></div>';
    document.body.appendChild(el);
    _el = el;
    document.getElementById('es-pc-x').addEventListener('click', hide);
    document.getElementById('es-pc-view').addEventListener('click', function () { hide(); if (window.CDC && typeof window.CDC.open === 'function') window.CDC.open(true); });
    document.getElementById('es-pc-rec-btn').addEventListener('click', onRecAdd);
    el.addEventListener('click', function (e) { if (e.target.closest('.es-pc-qv-trigger')) openQuickView(); });
  }

  /* ════════════════════════════════════════
     BUILD QUICK VIEW MODAL (once)
  ════════════════════════════════════════ */
  function buildQuickView() {
    if (_qvBuilt) return;
    _qvBuilt = true;
    var qv = document.createElement('div');
    qv.id = 'es-pc-qv';
    qv.innerHTML =
      '<div class="es-pc-qv-overlay" id="es-pc-qv-overlay">' +
        '<div class="es-pc-qv-modal" id="es-pc-qv-modal">' +
          '<button class="es-pc-qv-close" id="es-pc-qv-close" type="button">&times;</button>' +
          '<div class="es-pc-qv-scroll">' +
            '<div class="es-pc-qv-gallery" id="es-pc-qv-gallery"></div>' +
            '<div class="es-pc-qv-dots" id="es-pc-qv-dots"></div>' +
            '<div class="es-pc-qv-body">' +
              '<div class="es-pc-qv-badges" id="es-pc-qv-badges"></div>' +
              '<div class="es-pc-qv-title" id="es-pc-qv-title"></div>' +
              '<div class="es-pc-qv-subtitle" id="es-pc-qv-subtitle"></div>' +
              '<div class="es-pc-qv-stamped" id="es-pc-qv-stamped"></div>' +
              '<div class="es-pc-qv-price-row">' +
                '<span class="es-pc-qv-price" id="es-pc-qv-price"></span>' +
                '<span class="es-pc-qv-was" id="es-pc-qv-was"></span>' +
                '<span class="es-pc-qv-save" id="es-pc-qv-save"></span>' +
              '</div>' +
              '<div class="es-pc-qv-desc-wrap" id="es-pc-qv-desc-wrap">' +
                '<div class="es-pc-qv-desc" id="es-pc-qv-desc"></div>' +
                '<button class="es-pc-qv-desc-toggle" id="es-pc-qv-desc-toggle" type="button">See more</button>' +
              '</div>' +
              '<div class="es-pc-qv-bullets" id="es-pc-qv-bullets"></div>' +
              '<div class="es-pc-qv-variants" id="es-pc-qv-variants"></div>' +
              '<button class="es-pc-qv-atc" id="es-pc-qv-atc" type="button">Add to cart</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(qv);
    document.getElementById('es-pc-qv-overlay').addEventListener('click', function (e) { if (e.target === this) closeQuickView(); });
    document.getElementById('es-pc-qv-close').addEventListener('click', closeQuickView);
    document.getElementById('es-pc-qv-atc').addEventListener('click', onQvAdd);
  }

  /* ════════════════════════════════════════
     IMAGE GALLERY
  ════════════════════════════════════════ */
  function buildGallery(images) {
    var gallery = document.getElementById('es-pc-qv-gallery');
    var dotsEl = document.getElementById('es-pc-qv-dots');
    if (!gallery) return;
    if (!images || !images.length) { gallery.innerHTML = ''; dotsEl.innerHTML = ''; return; }
    var html = '<div class="es-pc-qv-gallery-track" id="es-pc-qv-track">';
    images.forEach(function (img, i) {
      var src = (typeof img === 'string' ? img : (img.src || '')).replace(/(\.[^.]+)(\?|$)/, '_800x$1$2');
      /* FIX 1: Product image alt text is safe (just numbered) */
      html += '<div class="es-pc-qv-slide"><img src="' + src + '" alt="Product image ' + (i + 1) + '" loading="' + (i === 0 ? 'eager' : 'lazy') + '"></div>';
    });
    html += '</div>';
    gallery.innerHTML = html;
    if (images.length > 1) {
      var dh = '';
      images.forEach(function (_, i) { dh += '<span class="es-pc-qv-dot' + (i === 0 ? ' active' : '') + '" data-idx="' + i + '"></span>'; });
      dotsEl.innerHTML = dh; dotsEl.style.display = 'flex';
      var track = document.getElementById('es-pc-qv-track');
      if (track) track.addEventListener('scroll', function () {
        var sw = track.children[0] ? track.children[0].offsetWidth : 1;
        var idx = Math.round(track.scrollLeft / sw);
        dotsEl.querySelectorAll('.es-pc-qv-dot').forEach(function (d, i) { d.classList.toggle('active', i === idx); });
      });
      dotsEl.addEventListener('click', function (e) {
        var dot = e.target.closest('.es-pc-qv-dot'); if (!dot) return;
        var idx = parseInt(dot.getAttribute('data-idx'), 10);
        var track = document.getElementById('es-pc-qv-track');
        if (track && track.children[idx]) track.children[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    } else { dotsEl.innerHTML = ''; dotsEl.style.display = 'none'; }
  }

  /* ════════════════════════════════════════
     QUICK VIEW OPEN / CLOSE
  ════════════════════════════════════════ */
  function openQuickView() {
    if (!_currentRec) return;
    buildQuickView();
    pauseTimer();
    _qvOpen = true;

    var overlay = document.getElementById('es-pc-qv-overlay');
    var titleEl = document.getElementById('es-pc-qv-title');
    var subtitleEl = document.getElementById('es-pc-qv-subtitle');
    var badgesEl = document.getElementById('es-pc-qv-badges');
    var stampedEl = document.getElementById('es-pc-qv-stamped');
    var priceEl = document.getElementById('es-pc-qv-price');
    var wasEl = document.getElementById('es-pc-qv-was');
    var saveEl = document.getElementById('es-pc-qv-save');
    var descWrap = document.getElementById('es-pc-qv-desc-wrap');
    var descEl = document.getElementById('es-pc-qv-desc');
    var descToggle = document.getElementById('es-pc-qv-desc-toggle');
    var bulletsEl = document.getElementById('es-pc-qv-bullets');
    var variantsEl = document.getElementById('es-pc-qv-variants');
    var atcBtn = document.getElementById('es-pc-qv-atc');
    var gallery = document.getElementById('es-pc-qv-gallery');

    /* Loading state */
    gallery.innerHTML = '<div class="es-pc-qv-loading">Loading...</div>';
    document.getElementById('es-pc-qv-dots').innerHTML = '';
    badgesEl.innerHTML = '';
    titleEl.textContent = _currentRec.title;
    subtitleEl.innerHTML = '';
    priceEl.textContent = fmt(_currentRec.price);
    wasEl.textContent = _currentRec.compareAt ? fmt(_currentRec.compareAt) : '';
    wasEl.style.display = _currentRec.compareAt ? 'inline' : 'none';
    if (_currentRec.compareAt) { saveEl.textContent = 'Save ' + fmt(_currentRec.compareAt - _currentRec.price); saveEl.style.display = 'inline'; }
    else { saveEl.style.display = 'none'; }
    stampedEl.innerHTML = '';
    descEl.textContent = ''; descWrap.style.display = 'none';
    descToggle.textContent = 'See more'; descToggle.style.display = 'none';
    bulletsEl.innerHTML = ''; variantsEl.innerHTML = '';
    atcBtn.textContent = 'Add to cart \u2014 ' + fmt(_currentRec.price);
    atcBtn.className = 'es-pc-qv-atc'; atcBtn.disabled = false;
    atcBtn.setAttribute('data-variant-id', String(_currentRec.variantId));
    overlay.classList.add('is-visible');

    fetchProductJson(_currentRec.handle).then(function (p) {
      if (!p) return;

      /* ── Badges ── */
      var badges = buildBadges(p);
      if (badges.length) {
        var bHtml = '';
        badges.forEach(function (b) { bHtml += '<span class="es-pc-badge ' + b.cls + '">' + esc(b.text) + '</span>'; });
        badgesEl.innerHTML = bHtml;
      }

      /* ── Title ── */
      titleEl.textContent = p.title;

      /* ── Subtitle: type + dimensions ── */
      var typeLabel = getTypeLabel(p);
      var dims = extractDimensions(p.handle);
      var subHtml = '<span class="es-pc-qv-type">' + esc(typeLabel) + '</span>';
      if (dims) subHtml += '<span class="es-pc-qv-sep">&middot;</span><span class="es-pc-qv-dims">' + esc(dims) + '</span>';
      subtitleEl.innerHTML = subHtml;

      /* ── Images ── */
      var images = p.images || [];
      if (!images.length && p.image) images = [p.image];
      buildGallery(images);

      /* ── Stamped reviews ── */
      stampedEl.innerHTML = '<span class="stamped-product-reviews-badge stamped-main-badge" data-id="' + p.id + '" data-product-sku="' + esc(p.handle || '') + '" data-product-type="' + esc(p.product_type || '') + '" data-product-title="' + esc(p.title || '') + '" style="font-size:13px"></span>';
      if (window.StampedFn && typeof window.StampedFn.loadBadges === 'function') setTimeout(function () { window.StampedFn.loadBadges(); }, 100);

      /* ── Price update from full data ── */
      var v0 = p.variants && p.variants[0];
      if (v0) {
        var pc = Math.round(parseFloat(v0.price) * 100);
        var cap = v0.compare_at_price ? Math.round(parseFloat(v0.compare_at_price) * 100) : 0;
        priceEl.textContent = fmt(pc);
        if (cap && cap > pc) {
          wasEl.textContent = fmt(cap); wasEl.style.display = 'inline';
          saveEl.textContent = 'Save ' + fmt(cap - pc); saveEl.style.display = 'inline';
        } else { wasEl.style.display = 'none'; saveEl.style.display = 'none'; }
        atcBtn.textContent = 'Add to cart \u2014 ' + fmt(pc);
      }

      /* ── Description ── */
      var cleanDesc = extractDescription(p.body_html);
      if (cleanDesc) {
        var TRUNCATE = 150;
        if (cleanDesc.length > TRUNCATE) {
          descEl.setAttribute('data-full', cleanDesc);
          descEl.setAttribute('data-short', cleanDesc.substring(0, TRUNCATE) + '...');
          descEl.textContent = cleanDesc.substring(0, TRUNCATE) + '...';
          descToggle.style.display = 'inline';
          descWrap.classList.remove('is-expanded');
        } else {
          descEl.textContent = cleanDesc;
          descToggle.style.display = 'none';
        }
        descWrap.style.display = 'block';
      }
      descToggle.onclick = function () {
        var full = descEl.getAttribute('data-full');
        var short = descEl.getAttribute('data-short');
        if (!full) return;
        var isExp = descWrap.classList.contains('is-expanded');
        descWrap.classList.toggle('is-expanded');
        descEl.textContent = isExp ? short : full;
        descToggle.textContent = isExp ? 'See more' : 'See less';
      };

      /* ── Bullets ── */
      var bullets = extractBullets(p.body_html);
      if (bullets.length) {
        var blHtml = '';
        bullets.forEach(function (b) { blHtml += '<div class="es-pc-qv-bullet"><span class="es-pc-qv-bdot"></span><span>' + esc(b) + '</span></div>'; });
        bulletsEl.innerHTML = blHtml;
      }

      /* ── Variants ── */
      if (p.variants && p.variants.length > 1) {
        var vHtml = '<div class="es-pc-qv-var-label">Option:</div><div class="es-pc-qv-var-pills">';
        p.variants.forEach(function (v, i) {
          var isActive = v.id === _currentRec.variantId;
          var isAvail = v.available !== false;
          var cls = 'es-pc-qv-pill' + (isActive ? ' active' : '') + (!isAvail ? ' oos' : '');
          var price = Math.round(parseFloat(v.price) * 100);
          var capV = v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0;
          vHtml += '<button class="' + cls + '" type="button" data-vid="' + v.id + '" data-price="' + price + '" data-cap="' + capV + '"' + (!isAvail ? ' disabled' : '') + '>' + esc(v.public_title || v.title || ('Option ' + (i + 1))) + '</button>';
        });
        vHtml += '</div>';
        variantsEl.innerHTML = vHtml;
        variantsEl.addEventListener('click', function (e) {
          var pill = e.target.closest('.es-pc-qv-pill');
          if (!pill || pill.classList.contains('oos')) return;
          variantsEl.querySelectorAll('.es-pc-qv-pill').forEach(function (pp) { pp.classList.remove('active'); });
          pill.classList.add('active');
          var vid = pill.getAttribute('data-vid');
          var price = parseInt(pill.getAttribute('data-price'), 10);
          var capP = parseInt(pill.getAttribute('data-cap'), 10);
          atcBtn.setAttribute('data-variant-id', vid);
          priceEl.textContent = fmt(price);
          if (capP && capP > price) {
            wasEl.textContent = fmt(capP); wasEl.style.display = 'inline';
            saveEl.textContent = 'Save ' + fmt(capP - price); saveEl.style.display = 'inline';
          } else { wasEl.style.display = 'none'; saveEl.style.display = 'none'; }
          atcBtn.textContent = 'Add to cart \u2014 ' + fmt(price);
        });
      }
    });
  }

  function closeQuickView() {
    _qvOpen = false;
    var overlay = document.getElementById('es-pc-qv-overlay');
    if (overlay) overlay.classList.remove('is-visible');
    resumeTimer();
  }

  /* ════════════════════════════════════════
     QUICK VIEW ADD
  ════════════════════════════════════════ */
  function onQvAdd() {
    var atcBtn = document.getElementById('es-pc-qv-atc');
    var vid = atcBtn.getAttribute('data-variant-id'); if (!vid) return;
    atcBtn.textContent = 'Adding...'; atcBtn.disabled = true;
    window._esPopCartActive = true; window._cdcBusy = true;
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] }) })
    .then(function (r) { return r.json(); })
    .then(function () {
      atcBtn.textContent = 'Added!'; atcBtn.className = 'es-pc-qv-atc is-added';
      /* FIX 4: Removed updateCartCount(1) — header updates via cart:updated event */
      if (window.ESCrossSell) window.ESCrossSell.invalidate();
      document.dispatchEvent(new CustomEvent('cdc:item-added'));
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      /* FIX 3: Broadcast cart:updated so header/sticky ATC update instantly */
      broadcastCartUpdate(cart);
      document.getElementById('es-pc-title').textContent = 'Added to your cart!';
      document.getElementById('es-pc-sub').textContent = (cart.item_count || 0) + ' item' + ((cart.item_count || 0) !== 1 ? 's' : '') + ' in your cart';
      updateShipping(cart.total_price || 0, getThreshold());
      setTimeout(function () {
        closeQuickView();
        if (window.ESCrossSell) {
          window.ESCrossSell.forCart({ limit: 1 }).then(function (recs) {
            if (recs && recs.length) { showNextRec(recs[0]); startTimer(); }
            else { document.getElementById('es-pc-rec').style.display = 'none'; _currentRec = null; startTimer(); }
          });
        } else { startTimer(); }
      }, 800);
    })
    .catch(function () { atcBtn.textContent = 'Try again'; atcBtn.className = 'es-pc-qv-atc'; atcBtn.disabled = false; })
    .finally(function () { window._cdcBusy = false; setTimeout(function () { window._esPopCartActive = false; }, 2000); });
  }

  /* ════════════════════════════════════════
     STYLES
  ════════════════════════════════════════ */
  function injectStyles() {
    if (document.getElementById('es-popcart-css')) return;
    var s = document.createElement('style');
    s.id = 'es-popcart-css';
    s.textContent =
      /* Toast — bottom on all devices */
      '#es-popcart{position:fixed;bottom:0;left:0;right:0;top:auto;z-index:99995;font-family:"Montserrat",-apple-system,sans-serif;-webkit-font-smoothing:antialiased;transform:translateY(100%);opacity:0;transition:transform .35s cubic-bezier(.22,.61,.36,1),opacity .25s;pointer-events:none;border-radius:16px 16px 0 0;box-shadow:0 -4px 24px rgba(0,0,0,.12);border-top:1px solid #e8e8e8;overflow:hidden;padding-bottom:env(safe-area-inset-bottom,0)}' +
      '#es-popcart.is-visible{transform:translateY(0);opacity:1;pointer-events:auto}' +
      '#es-popcart .es-pc-confirm{padding:14px 16px 10px;display:flex;align-items:center;gap:10px;background:#fff;border-bottom:1px solid #f5f5f5;border-radius:16px 16px 0 0}' +
      '#es-popcart .es-pc-check{width:22px;height:22px;border-radius:50%;background:#2E7D32;display:flex;align-items:center;justify-content:center;flex-shrink:0}' +
      '#es-popcart .es-pc-msg{flex:1;min-width:0}' +
      '#es-popcart .es-pc-title{font-size:14px;font-weight:700;color:#2D2D2D}' +
      '#es-popcart .es-pc-sub{font-size:12px;color:#999;margin-top:1px}' +
      '#es-popcart .es-pc-actions{display:flex;align-items:center;gap:10px;flex-shrink:0}' +
      '#es-popcart .es-pc-view{background:#1BAFF0;border:none;font-family:inherit;font-size:13px;font-weight:700;color:#fff;cursor:pointer;padding:10px 18px;border-radius:6px;white-space:nowrap;transition:opacity .15s}' +
      '#es-popcart .es-pc-view:hover{opacity:.88}' +
      '#es-popcart .es-pc-x{background:none;border:none;font-size:22px;color:#ccc;cursor:pointer;padding:4px 6px;line-height:1}' +
      '#es-popcart .es-pc-rec{padding:0 14px 12px;background:#fff}' +
      '#es-popcart .es-pc-rec-card{display:flex;gap:12px;align-items:center;padding:12px;background:#f9fafb;border-radius:10px}' +
      '#es-popcart .es-pc-rec-img{width:80px;height:80px;border-radius:8px;background:#f0f2f4;flex-shrink:0;border:1px solid #eee;overflow:hidden;cursor:pointer}' +
      '#es-popcart .es-pc-rec-img img{width:100%;height:100%;object-fit:cover;display:block}' +
      '#es-popcart .es-pc-rec-info{flex:1;min-width:0}' +
      '#es-popcart .es-pc-rec-label{font-size:10px;font-weight:600;color:#2E7D32;margin-bottom:2px}' +
      '#es-popcart .es-pc-rec-name{font-size:14px;font-weight:600;color:#2D2D2D;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:pointer}' +
      '#es-popcart .es-pc-rec-name:hover{color:#1BAFF0;text-decoration:underline}' +
      '#es-popcart .es-pc-rec-pr{font-size:14px;color:#636363;margin-top:2px}' +
      '#es-popcart .es-pc-rec-was{font-size:11px;color:#bbb;text-decoration:line-through;margin-left:4px}' +
      '#es-popcart .es-pc-rec-btns{display:flex;flex-direction:column;gap:5px;align-items:center;flex-shrink:0}' +
      '#es-popcart .es-pc-rec-btn{padding:12px 22px;background:#1BAFF0;color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:700;cursor:pointer;font-family:inherit;white-space:nowrap;transition:all .15s;min-height:48px;min-width:70px;text-align:center}' +
      '#es-popcart .es-pc-rec-btn:hover{opacity:.88}' +
      '#es-popcart .es-pc-rec-btn:active{transform:scale(.97)}' +
      '#es-popcart .es-pc-rec-btn.is-added{background:#2E7D32;pointer-events:none}' +
      '#es-popcart .es-pc-qv-btn{font-size:12px;color:#1BAFF0;cursor:pointer;text-decoration:underline;background:none;border:none;font-family:inherit;padding:0}' +
      '#es-popcart .es-pc-ship{padding:0 14px 12px;background:#fff}' +
      '#es-popcart .es-pc-ship-bar{height:4px;background:#eee;border-radius:2px;overflow:hidden;margin-bottom:5px}' +
      '#es-popcart .es-pc-ship-fill{height:100%;border-radius:2px;transition:width .5s,background .3s}' +
      '#es-popcart .es-pc-ship-text{font-size:12px;font-weight:600;color:#999;text-align:center}' +
      '#es-popcart .es-pc-timer{height:3px;background:#f0f0f0;overflow:hidden}' +
      '#es-popcart .es-pc-timer-fill{height:100%;background:#1BAFF0;border-radius:1px;width:100%}' +
      '@media(min-width:768px){#es-popcart{left:auto;right:0;max-width:440px;border-radius:16px 0 0 0;border-right:none}}' +

      /* ═══ Quick View Modal ═══ */
      '#es-pc-qv .es-pc-qv-overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);z-index:99998;opacity:0;visibility:hidden;transition:opacity .25s,visibility .25s}' +
      '#es-pc-qv .es-pc-qv-overlay.is-visible{opacity:1;visibility:visible}' +
      '#es-pc-qv .es-pc-qv-modal{position:absolute;bottom:0;left:0;right:0;background:#fff;max-height:92vh;border-radius:16px 16px 0 0;overflow:hidden;transform:translateY(30px);transition:transform .3s cubic-bezier(.22,.61,.36,1);padding-bottom:env(safe-area-inset-bottom,0)}' +
      '#es-pc-qv .es-pc-qv-overlay.is-visible .es-pc-qv-modal{transform:translateY(0)}' +
      '#es-pc-qv .es-pc-qv-scroll{overflow-y:auto;-webkit-overflow-scrolling:touch;max-height:92vh}' +
      '#es-pc-qv .es-pc-qv-close{position:absolute;top:12px;right:12px;width:34px;height:34px;background:rgba(255,255,255,0.9);border:none;border-radius:50%;font-size:18px;color:#999;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:2}' +
      '#es-pc-qv .es-pc-qv-close:hover{color:#666}' +

      '#es-pc-qv .es-pc-qv-gallery{overflow:hidden}' +
      '#es-pc-qv .es-pc-qv-gallery-track{display:flex;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch}' +
      '#es-pc-qv .es-pc-qv-gallery-track::-webkit-scrollbar{display:none}' +
      '#es-pc-qv .es-pc-qv-slide{flex:0 0 100%;scroll-snap-align:start;background:#f5f5f5}' +
      '#es-pc-qv .es-pc-qv-slide img{width:100%;height:auto;display:block}' +
      '#es-pc-qv .es-pc-qv-dots{display:flex;justify-content:center;gap:6px;padding:10px 0}' +
      '#es-pc-qv .es-pc-qv-dot{width:8px;height:8px;border-radius:50%;background:#ddd;cursor:pointer;transition:background .2s}' +
      '#es-pc-qv .es-pc-qv-dot.active{background:#1BAFF0}' +
      '#es-pc-qv .es-pc-qv-loading{text-align:center;padding:60px 0;font-size:13px;color:#bbb;font-family:"Montserrat",sans-serif}' +

      '#es-pc-qv .es-pc-qv-badges{display:flex;gap:6px;flex-wrap:wrap;margin-bottom:8px}' +
      '.es-pc-badge{display:inline-block;font-size:11px;font-weight:700;padding:4px 10px;border-radius:4px;text-transform:uppercase;letter-spacing:0.03em;font-family:"Montserrat",sans-serif}' +
      '.es-pc-badge-green{background:#2E7D32;color:#fff}' +
      '.es-pc-badge-blue{background:#1BAFF0;color:#fff}' +
      '.es-pc-badge-red{background:#990300;color:#fff}' +

      '#es-pc-qv .es-pc-qv-body{padding:4px 18px 20px;font-family:"Montserrat",-apple-system,sans-serif}' +
      '#es-pc-qv .es-pc-qv-title{font-family:"Libre Baskerville",Georgia,serif;font-size:22px;color:#1BAFF0;margin-bottom:4px;line-height:1.3;font-weight:400}' +
      '#es-pc-qv .es-pc-qv-subtitle{display:flex;align-items:center;gap:6px;margin-bottom:6px;font-size:12px}' +
      '#es-pc-qv .es-pc-qv-type{font-weight:700;color:#999;text-transform:uppercase;letter-spacing:0.04em}' +
      '#es-pc-qv .es-pc-qv-sep{color:#ccc}' +
      '#es-pc-qv .es-pc-qv-dims{color:#999}' +
      '#es-pc-qv .es-pc-qv-stamped{margin-bottom:8px;min-height:20px}' +
      '#es-pc-qv .es-pc-qv-stamped .stamped-badge-caption{display:none!important}' +
      '#es-pc-qv .es-pc-qv-price-row{display:flex;align-items:center;gap:8px;margin-bottom:14px;flex-wrap:wrap}' +
      '#es-pc-qv .es-pc-qv-price{font-size:22px;font-weight:700;color:#2D2D2D}' +
      '#es-pc-qv .es-pc-qv-was{font-size:15px;color:#bbb;text-decoration:line-through}' +
      '#es-pc-qv .es-pc-qv-save{font-size:11px;font-weight:700;color:#990300;background:#FFEBEE;padding:3px 8px;border-radius:10px}' +

      '#es-pc-qv .es-pc-qv-desc-wrap{margin-bottom:12px}' +
      '#es-pc-qv .es-pc-qv-desc{font-size:14px;color:#636363;line-height:1.6}' +
      '#es-pc-qv .es-pc-qv-desc-toggle{font-size:13px;color:#1BAFF0;cursor:pointer;background:none;border:none;font-family:inherit;padding:0;margin-top:4px;font-weight:600}' +

      '#es-pc-qv .es-pc-qv-bullets{margin-bottom:12px}' +
      '#es-pc-qv .es-pc-qv-bullet{display:flex;gap:8px;align-items:flex-start;margin-bottom:8px;font-size:14px;color:#636363;line-height:1.5}' +
      '#es-pc-qv .es-pc-qv-bullet:last-child{margin-bottom:0}' +
      '#es-pc-qv .es-pc-qv-bdot{width:6px;height:6px;border-radius:50%;background:#1BAFF0;flex-shrink:0;margin-top:7px}' +

      '#es-pc-qv .es-pc-qv-variants{margin-bottom:16px}' +
      '#es-pc-qv .es-pc-qv-var-label{font-size:12px;font-weight:600;color:#999;margin-bottom:8px}' +
      '#es-pc-qv .es-pc-qv-var-pills{display:flex;gap:8px;flex-wrap:wrap}' +
      '#es-pc-qv .es-pc-qv-pill{padding:10px 18px;border:1.5px solid #e0e0e0;border-radius:8px;font-size:13px;font-weight:600;color:#636363;cursor:pointer;background:#fff;font-family:inherit;transition:all .15s;min-height:44px}' +
      '#es-pc-qv .es-pc-qv-pill:hover{border-color:#1BAFF0;color:#1BAFF0}' +
      '#es-pc-qv .es-pc-qv-pill.active{border-color:#1BAFF0;background:#E8F6FD;color:#0878B4}' +
      '#es-pc-qv .es-pc-qv-pill.oos{opacity:.35;cursor:not-allowed;text-decoration:line-through}' +

      '#es-pc-qv .es-pc-qv-atc{width:100%;padding:16px;background:#1BAFF0;color:#fff;border:none;border-radius:10px;font-size:15px;font-weight:700;font-family:inherit;cursor:pointer;transition:all .15s;min-height:52px}' +
      '#es-pc-qv .es-pc-qv-atc:hover{opacity:.88}' +
      '#es-pc-qv .es-pc-qv-atc:active{transform:scale(.98)}' +
      '#es-pc-qv .es-pc-qv-atc.is-added{background:#2E7D32;pointer-events:none}' +

      '@media(min-width:768px){#es-pc-qv .es-pc-qv-modal{left:auto;right:0;max-width:480px;border-radius:16px 0 0 0}#es-pc-qv .es-pc-qv-scroll{max-height:92vh}}' +

      /* FIX 2: Uses .esatc class (not hardcoded #es-sticky-atc ID) to match dynamic section ID */
      'body.es-popcart-open .esatc{transform:translateY(100%)!important;opacity:0!important;visibility:hidden!important;pointer-events:none!important}';
    document.head.appendChild(s);
  }

  /* ════════════════════════════════════════
     TIMER
  ════════════════════════════════════════ */
  function startTimer() {
    if (_timer) clearTimeout(_timer);
    _timerRemaining = TOAST_DURATION; _timerStart = Date.now();
    var tf = document.getElementById('es-pc-timer-fill');
    if (tf) { tf.style.transition = 'none'; tf.style.width = '100%'; void tf.offsetWidth; tf.style.transition = 'width ' + (TOAST_DURATION / 1000) + 's linear'; tf.style.width = '0%'; }
    _timer = setTimeout(hide, TOAST_DURATION + 200);
  }
  function pauseTimer() {
    if (_timer) { clearTimeout(_timer); _timer = null; }
    _timerRemaining = Math.max(0, TOAST_DURATION - (Date.now() - _timerStart));
    var tf = document.getElementById('es-pc-timer-fill');
    if (tf) { tf.style.transition = 'none'; tf.style.width = (_timerRemaining / TOAST_DURATION * 100) + '%'; }
  }
  function resumeTimer() {
    if (_timerRemaining <= 0) { hide(); return; }
    _timerStart = Date.now();
    var tf = document.getElementById('es-pc-timer-fill');
    if (tf) { void tf.offsetWidth; tf.style.transition = 'width ' + (_timerRemaining / 1000) + 's linear'; tf.style.width = '0%'; }
    _timer = setTimeout(hide, _timerRemaining + 200);
  }

  /* ════════════════════════════════════════
     SHOW / HIDE TOAST
  ════════════════════════════════════════ */
  function show(cartData, recProduct) {
    build();
    var count = cartData.item_count || 0;
    document.getElementById('es-pc-title').textContent = 'Added to your cart!';
    document.getElementById('es-pc-sub').textContent = count + ' item' + (count !== 1 ? 's' : '') + ' in your cart';
    var recEl = document.getElementById('es-pc-rec');
    if (recProduct) {
      recEl.style.display = 'block'; _currentRec = recProduct;
      /* FIX 1: Escape product title in img alt attribute */
      document.getElementById('es-pc-rec-img').innerHTML = recProduct.image ? '<img src="' + recProduct.image + '" alt="' + esc(recProduct.title) + '" loading="lazy">' : '';
      document.getElementById('es-pc-rec-label').textContent = 'Makers also grab';
      document.getElementById('es-pc-rec-name').textContent = recProduct.title;
      document.getElementById('es-pc-rec-price').textContent = fmt(recProduct.price);
      document.getElementById('es-pc-rec-was').textContent = recProduct.compareAt ? fmt(recProduct.compareAt) : '';
      var btn = document.getElementById('es-pc-rec-btn');
      btn.textContent = 'Add'; btn.className = 'es-pc-rec-btn';
      btn.setAttribute('data-variant-id', String(recProduct.variantId));
    } else { recEl.style.display = 'none'; _currentRec = null; }
    updateShipping(cartData.total_price || 0, getThreshold());
    startTimer();
    document.body.classList.add('es-popcart-open');
    _el.classList.add('is-visible');
  }

  function hide() {
    if (!_el) return;
    _el.classList.remove('is-visible');
    document.body.classList.remove('es-popcart-open');
    if (_qvOpen) closeQuickView();
    if (_timer) { clearTimeout(_timer); _timer = null; }
  }

  function updateShipping(total, threshold) {
    var gap = Math.max(0, threshold - total);
    var pct = Math.min(Math.round((total / threshold) * 100), 100);
    var fill = document.getElementById('es-pc-ship-fill');
    var text = document.getElementById('es-pc-ship-text');
    if (!fill || !text) return;
    fill.style.width = pct + '%';
    if (gap <= 0) { fill.style.background = '#2E7D32'; text.innerHTML = '<span style="color:#2E7D32">FREE shipping unlocked!</span>'; }
    else { fill.style.background = '#1BAFF0'; text.innerHTML = '<span style="color:#1BAFF0;font-weight:700">' + fmt(gap) + '</span> away from FREE shipping'; }
  }

  /* ════════════════════════════════════════
     TOAST REC ADD
  ════════════════════════════════════════ */
  function onRecAdd() {
    var btn = document.getElementById('es-pc-rec-btn');
    var vid = btn.getAttribute('data-variant-id'); if (!vid) return;
    btn.textContent = 'Adding...'; btn.className = 'es-pc-rec-btn is-added';
    window._esPopCartActive = true; window._cdcBusy = true;
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] }) })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.textContent = 'Added!';
      /* FIX 4: Removed updateCartCount(1) — header updates via cart:updated event */
      if (window.ESCrossSell) window.ESCrossSell.invalidate();
      document.dispatchEvent(new CustomEvent('cdc:item-added'));
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      /* FIX 3: Broadcast cart:updated so header/sticky ATC update instantly */
      broadcastCartUpdate(cart);
      document.getElementById('es-pc-title').textContent = 'Added to your cart!';
      document.getElementById('es-pc-sub').textContent = (cart.item_count || 0) + ' item' + ((cart.item_count || 0) !== 1 ? 's' : '') + ' in your cart';
      updateShipping(cart.total_price || 0, getThreshold());
      if (window.ESCrossSell) {
        window.ESCrossSell.forCart({ limit: 1 }).then(function (recs) {
          if (recs && recs.length) { showNextRec(recs[0]); startTimer(); }
          else { document.getElementById('es-pc-rec').style.display = 'none'; _currentRec = null; startTimer(); }
        });
      } else { startTimer(); }
    })
    .catch(function () { btn.textContent = 'Try again'; btn.className = 'es-pc-rec-btn'; })
    .finally(function () { window._cdcBusy = false; setTimeout(function () { window._esPopCartActive = false; }, 2000); });
  }

  function showNextRec(product) {
    document.getElementById('es-pc-rec').style.display = 'block'; _currentRec = product;
    /* FIX 1: Escape product title in img alt attribute */
    document.getElementById('es-pc-rec-img').innerHTML = product.image ? '<img src="' + product.image + '" alt="' + esc(product.title) + '" loading="lazy">' : '';
    document.getElementById('es-pc-rec-label').textContent = 'Makers also grab';
    document.getElementById('es-pc-rec-name').textContent = product.title;
    document.getElementById('es-pc-rec-price').textContent = fmt(product.price);
    document.getElementById('es-pc-rec-was').textContent = product.compareAt ? fmt(product.compareAt) : '';
    var btn = document.getElementById('es-pc-rec-btn');
    btn.textContent = 'Add'; btn.className = 'es-pc-rec-btn';
    btn.setAttribute('data-variant-id', String(product.variantId));
  }

  /* ════════════════════════════════════════
     ROUTE: toast on mobile, drawer on desktop
  ════════════════════════════════════════ */
  function routeAfterAdd(cartData, recProduct) {
    if (window.innerWidth >= 768 && window.CDC && typeof window.CDC.open === 'function') {
      window._esPopCartActive = false;
      window.CDC.open();
    } else {
      show(cartData, recProduct);
    }
  }

  /* ════════════════════════════════════════
     INTERCEPT ADD TO CART
  ════════════════════════════════════════ */
  function intercept() {
    var _origFetch = window.fetch;
    window.fetch = function (resource, init) {
      var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
      var result = _origFetch.apply(this, arguments);
      if (url.indexOf('/cart/add') !== -1 && !window._cdcBusy && !window._esPopCartActive) {
        window._esPopCartActive = true;
        result.then(function (response) {
          if (!response.ok) return;
          return response.clone().json().then(function () {
            /* FIX 4: Removed updateCartCount(1) — header updates via cart:updated event */
            document.dispatchEvent(new CustomEvent('cdc:item-added'));
            var cartP = fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
            var recP = window.ESCrossSell ? window.ESCrossSell.forCart({ limit: 1 }) : Promise.resolve([]);
            return Promise.all([cartP, recP]).then(function (r) {
              /* FIX 3: Broadcast cart:updated so header/sticky ATC update instantly */
              broadcastCartUpdate(r[0]);
              routeAfterAdd(r[0], r[1] && r[1][0] ? r[1][0] : null);
            });
          });
        }).catch(function () {}).finally(function () { setTimeout(function () { window._esPopCartActive = false; }, 2000); });
      }
      return result;
    };
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action="/cart/add"], form[action*="/cart/add"]')) return;
      e.preventDefault(); e.stopPropagation();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      var btnSpan = submitBtn ? (submitBtn.querySelector('.text, span') || submitBtn) : null;
      var origText = btnSpan ? (btnSpan.getAttribute('data-es-orig') || btnSpan.textContent.trim()) : '';
      if (btnSpan && !btnSpan.getAttribute('data-es-orig')) btnSpan.setAttribute('data-es-orig', origText);
      if (btnSpan) btnSpan.textContent = 'Adding...';
      if (submitBtn) submitBtn.disabled = true;
      window._esPopCartActive = true; window._cdcBusy = true;
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', body: formData })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btnSpan) btnSpan.textContent = 'Added!';
        /* FIX 4: Removed updateCartCount(1) — header updates via cart:updated event */
        document.dispatchEvent(new CustomEvent('cdc:item-added'));
        var cartP = fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
        var recP = window.ESCrossSell ? window.ESCrossSell.forCart({ limit: 1 }) : Promise.resolve([]);
        return Promise.all([cartP, recP]).then(function (r) {
          /* FIX 3: Broadcast cart:updated so header/sticky ATC update instantly */
          broadcastCartUpdate(r[0]);
          routeAfterAdd(r[0], r[1] && r[1][0] ? r[1][0] : null);
        });
      })
      .catch(function (err) { console.error('PopCart: add error', err); if (btnSpan) btnSpan.textContent = origText; })
      .finally(function () {
        window._cdcBusy = false; setTimeout(function () { window._esPopCartActive = false; }, 2000);
        if (submitBtn) submitBtn.disabled = false;
        setTimeout(function () { if (btnSpan) btnSpan.textContent = origText; }, 1500);
      });
    }, true);
  }

  /* ════════════════════════════════════════
     INIT
  ════════════════════════════════════════ */
  function init() { injectStyles(); build(); intercept(); window.ESPopCart = { show: show, hide: hide }; }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

})();